import React from 'react';
import { Header } from 'layout';
import { UserOpenOrdersTable } from 'modules';
import { useGetIndependentIraUser } from 'hooks/api/independentIra';
import { useGetProfileOpenOrders } from 'hooks/api/portfolio';
import { USER_TYPE } from 'constants/userTypes';
import { USER_STATUS } from 'constants/status';
import { EntityStatus } from 'components/Label';
import StatusUserButton from 'components/StatusUserButton';
import EmptyPage from 'components/EmptyPage';
import IndependentIraNavTabs from '../components/IndependentIraNavTabs';
import IndependentIraBalance from '../components/IndependentIraBalance';
import IndependentIraActiveLimitOrders from '../components/IndependentIraActiveLimitOrders';

import styles from './IndependentIraOpenOrders.module.css';

const IndependentIraOpenOrders: React.FC = () => {
  const { data: independentIraUser } = useGetIndependentIraUser();
  const {
    data: transactionsData,
    isLoading: portfolioTransactionsLoading,
    isError,
    refetch,
    isRefetching,
    isSuccess,
  } = useGetProfileOpenOrders();

  return (
    <>
      <Header
        title={
          independentIraUser
            ? `${independentIraUser?.firstName} ${independentIraUser?.middleName ?? ''} ${
                independentIraUser?.lastName
              }`
            : ''
        }
        complexComponent={true}
        label={{
          status: independentIraUser?.profileStatus,
          entityStatus: EntityStatus.User,
          isAccountClosed: independentIraUser?.accountClosed,
        }}
      >
        {independentIraUser && (
          <StatusUserButton
            user={independentIraUser}
            userType={USER_TYPE.independentIra}
          />
        )}
      </Header>

      <IndependentIraNavTabs />

      {independentIraUser?.profileStatus === USER_STATUS.active ? (
        <>
          <div className={styles.metricsWrapper}>
            <IndependentIraBalance />
            <IndependentIraActiveLimitOrders enableToFetch={isSuccess} />
          </div>
          <UserOpenOrdersTable
            transactionsData={transactionsData}
            portfolioTransactionsLoading={portfolioTransactionsLoading}
            isError={isError}
            isRefetching={isRefetching}
            refetch={refetch}
          />
        </>
      ) : (
        <EmptyPage />
      )}
    </>
  );
};

export default IndependentIraOpenOrders;
